<footer class="small-footer">
  <p>DOME Registry - Department of Biomedical Sciences - University of Padua, Italy</p>
  <div class="right">
    <span><img src="../../assets/UniPD_logo.svg" alt="UNIPD logo"></span>
    <span><img src="assets/DSB_logo.svg" alt="Department of Biomedical science logo"> </span>
    <span><img src="assets/bio-c-white.svg" alt="Biocomputing Lab logo"></span>
    <span><img src="assets/ELIXIR_ITALY_colour_background.svg" alt="Elixir Italy logo"></span>
  </div>
</footer>
